import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../App";
import axios from "axios";
import { API_URL } from "../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import {
  handleUserLevelAccessPermissions
} from "../../../Custom/Custom";
import { ToastContainer, toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import messages from '../../../assets/Messages.json';
import titlesData from '../../../titles.json';

function CentralStoreFigures() {
  const [years, setYears] = useState([]);
  const [yearName, setYearName] = useState("");
  const [fileType, setFileType] = useState("");
  const [file, setFile] = useState(null);
  const [buttonAccess, setButtonAccess] = useState({
    userLevel: "",
    roles: "",
    isVisible: false,
  });
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level);
    
    // Get Survey Years: current year to 2021 (descending order - current year on top)
    const getYearList = () => {
      const currentYear = new Date().getFullYear();
      const startYear = 2021;
      const yearsList = [];
      for (let year = currentYear; year >= startYear; year--) {
        yearsList.push(year);
      }
      setYears(yearsList);
    };

    getYearList();
  }, []);

  const handleDropdownChange = (e) => {
    switch (e.target.name) {
      case "yearName":
        setYearName(e.target.value);
        break;
      case "fileType":
        setFileType(e.target.value);
        break;
      default:
        console.log("switch case are not match");
        break;
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const fileNameParts = selectedFile.name.split('.');
      const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();
      
      if (fileExtension !== 'txt') {
        toast.error("Please Upload text file", messages.COLOR_RED);
        e.target.value = "";
        setFile(null);
        return;
      }

      setFile(selectedFile);
    }
  };

  const submitFormData = async () => {
    if (yearName === '') {
      toast.error('Please select year', messages.COLOR_RED);
      return;
    }
      
    if (fileType === '') {
      toast.error("Please Select file type", messages.COLOR_RED);
      return;
    }

    if (file === null) {
      toast.error("Please select file to upload.", messages.COLOR_RED);
      return;
    }

    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts[fileNameParts.length - 1].toLowerCase();
 
    if (fileExtension !== 'txt') {
      toast.error("Please Upload text file", messages.COLOR_RED);
      return;
    }

    showLoading(true);
    const formData = new FormData();
      
    let post_data = {
      fileType: fileType,
      survey_year: yearName,
    };
  
    const newObjectString = JSON.stringify(post_data);
    formData.append('file', file);
    formData.append('fileinfo', newObjectString);
    
    try {
      // TODO: Update API endpoint when backend is ready
      const response = await axios.post(`${API_URL}api/iip/uploadCentralStoreFigures`, formData, {
        ...config,
        headers: {
          ...config.headers,
          'Content-Type': 'multipart/form-data',
        },
      });
      const res = response.data;
     
      if (res.status) {
        toast.success(res.message, messages.COLOR_RED);
        setYearName('');
        setFileType('');
        setFile(null);
        const fileInput = document.getElementById('fileInput');
        if (fileInput) {
          fileInput.value = '';
        }
      } else {
        toast.error(res.message || 'File is not Uploaded', messages.COLOR_RED);
      }
    } catch (error) {
      console.error('Error posting data:', error);
      toast.error("An error occurred while uploading the file.", messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
  };

  const storedLanguage = localStorage.getItem('language');

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
          <div className="card-body pb-1">
            <div className="row align-items-center">
              <h4 className="page_heading">
                <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? titlesData.hi.CentralStoreFigures : titlesData.en.CentralStoreFigures }} />
              </h4>

              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>Survey Year</label>
                  <select
                    name="yearName"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={yearName}
                  >
                    <option value="" disabled>
                      Select Year
                    </option>
                    {years &&
                      years.map((ele, index) => (
                        <option key={index} value={ele}>
                          {ele}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>File Type</label>
                  <select
                    name="fileType"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={fileType}
                  >
                    <option value="" disabled>
                      [--Select--]
                    </option>
                    {/* TODO: Add file type options when available */}
                    <option value="central">Central</option>
                    
                  </select>
                </div>

                {/* <div className="col-xl-4 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>Please upload a file (.txt)</label>
                  <input
                    type="file"
                    id="fileInput"
                    className="form-control"
                    accept=".txt"
                    onChange={handleFileChange}
                  />
                </div> */}

                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                  <label>&nbsp;</label>
                  <button
                    type="button"
                    className="btn btn_orange w-100"
                    onClick={submitFormData}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CentralStoreFigures;
